"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CatalogSortDirection = exports.CatalogSortBy = void 0;
/**
 * All the possible sort options for the Marketplace's catalog.
 * @public
 */

var CatalogSortBy;

(function (CatalogSortBy) {
  CatalogSortBy["NEWEST"] = "newest";
  CatalogSortBy["RECENTLY_SOLD"] = "recently_sold";
  CatalogSortBy["CHEAPEST"] = "cheapest";
  CatalogSortBy["MOST_EXPENSIVE"] = "most_expensive";
  CatalogSortBy["RECENTLY_LISTED"] = "recently_listed";
})(CatalogSortBy = exports.CatalogSortBy || (exports.CatalogSortBy = {}));
/**
 * All the possible sort directions.
 * @public
 */


var CatalogSortDirection;

(function (CatalogSortDirection) {
  CatalogSortDirection["ASC"] = "asc";
  CatalogSortDirection["DESC"] = "desc";
})(CatalogSortDirection = exports.CatalogSortDirection || (exports.CatalogSortDirection = {}));